import React from "react";
import { comparisonTableHtml } from "../data/comparison-table.data";

const ComparisonTableHtml = () => (
    <div
        className="comparison-table-html"
        dangerouslySetInnerHTML={{ __html: comparisonTableHtml }}
    />
);

export default ComparisonTableHtml;
